function addToXbWishlist(productId, variantId) {
  const config = window.xb_wishlist || {};
  const payload = {
    action: 'add',
    customerId: config.customerId || '',
    productId: String(productId),
    shop: config.myShopify || '',
    variantId: String(variantId),
    sessionId: '',
  };

  return fetch('/tools/xb-wishlist', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (!response.ok) throw new Error('xb-wishlist add request failed');
      return fetch('/tools/xb-wishlist/update-count', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productId: String(productId), action: 'increment' }),
      });
    })
    .then(() => {
      // Calling the app's proxy endpoints directly (rather than clicking its own button)
      // doesn't update its UI, so replicate the event it dispatches after adding an item
      // to make the header badge and other XB Wishlist components refresh live.
      document.dispatchEvent(
        new CustomEvent('xb-wishlist:update-state', { detail: { state: 'added' }, bubbles: true, composed: true })
      );
    })
    .catch((error) => {
      console.error('There was a problem adding the item to the wishlist:', error);
    });
}

// Kaching Cart's own line items don't expose a variant id near the remove button,
// only data-product-id. Resolve the variant by matching this line's position against
// the live /cart.js items array, which the drawer's own contents are rendered from.
function resolveVariantId(lineItemEl, productId) {
  const allLines = Array.from(document.querySelectorAll('#kaching-cart .kaching-cart-item'));
  const index = allLines.indexOf(lineItemEl);

  return fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      const byPosition = cart.items[index];
      if (byPosition && String(byPosition.product_id) === String(productId)) {
        return byPosition.variant_id;
      }
      const byProduct = cart.items.find((item) => String(item.product_id) === String(productId));
      return byProduct ? byProduct.variant_id : null;
    });
}

class KachingCartRemoveConfirm {
  constructor(modal) {
    this.modal = modal;
    this.pendingButton = null;
    this.imageEl = modal.querySelector('.cart-remove-confirm-modal__image');
    this.closeButton = modal.querySelector('.cart-remove-confirm-modal__close');
    this.wishlistButton = modal.querySelector('.cart-remove-confirm-modal__wishlist');
    this.removeButton = modal.querySelector('.cart-remove-confirm-modal__remove');

    this.closeButton.addEventListener('click', () => this.close());
    this.wishlistButton.addEventListener('click', () => this.confirmWishlist());
    this.removeButton.addEventListener('click', () => this.confirmRemove());
    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) this.close();
    });
    this.modal.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    // Capture phase, so this runs before Kaching Cart's own listener and can block it.
    document.addEventListener(
      'click',
      (event) => {
        const removeButton = event.target.closest('.kaching-cart-item__remove-btn');
        const decrementButton = event.target.closest('.kaching-cart-item__quantity-btn--decrement');
        const button = removeButton || decrementButton;
        if (!button) return;

        if (button.dataset.removeConfirmed === 'true') {
          delete button.dataset.removeConfirmed;
          return;
        }

        if (decrementButton) {
          const lineItem = decrementButton.closest('.kaching-cart-item');
          const qtyInput = lineItem ? lineItem.querySelector('.kaching-cart-item__quantity-input') : null;
          const currentQty = qtyInput ? parseInt(qtyInput.value, 10) : null;
          // Only the last unit's decrement removes the line - anything above that should decrement normally.
          if (currentQty !== 1) return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        this.open(button);
      },
      true
    );
  }

  open(button) {
    const lineItem = button.closest('.kaching-cart-item');
    const productId = lineItem.dataset.productId;
    const image = lineItem.querySelector('img');
    const title = lineItem.querySelector('.kaching-cart-item__title');

    this.pendingButton = button;
    this.pendingProductId = productId;

    if (image) {
      this.imageEl.src = image.src;
      this.imageEl.alt = title ? title.textContent.trim() : '';
      this.imageEl.hidden = false;
    } else {
      this.imageEl.hidden = true;
    }

    this.modal.setAttribute('open', '');
    this.closeButton.focus();

    this.pendingVariantIdPromise = resolveVariantId(lineItem, productId);
  }

  close() {
    this.pendingButton = null;
    this.pendingProductId = null;
    this.pendingVariantIdPromise = null;
    this.modal.removeAttribute('open');
  }

  confirmRemove() {
    const button = this.pendingButton;
    if (!button) return;
    this.close();

    button.dataset.removeConfirmed = 'true';
    button.click();
  }

  confirmWishlist() {
    const button = this.pendingButton;
    const productId = this.pendingProductId;
    const variantIdPromise = this.pendingVariantIdPromise;
    if (!button) return;
    this.close();

    variantIdPromise
      .then((variantId) => addToXbWishlist(productId, variantId))
      .finally(() => {
        button.dataset.removeConfirmed = 'true';
        button.click();
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('KachingCartRemoveConfirmModal');
  if (modal) {
    window.kachingCartRemoveConfirm = new KachingCartRemoveConfirm(modal);
  }
});
